module.exports = __webpack_public_path__ + "static/media/2.101791c1.JPG";